export default __webpack_public_path__ + "static/media/ConveyorPoleMulti.256.ee68f07f.png";